export default __webpack_public_path__ + "static/media/contact.acb301b6.mp4";